export default __webpack_public_path__ + "static/media/Jain-Tour.1c3f0182.jpg";